import React from 'react'
import { PreloaderLine } from '@rst/ui-ts'
import { calcBlockHeight, formatText, usePreloaderFont } from '@rst/libs-ts'
import styled from 'styled-components'

export const LeadFormVerticalMobPreloader = (data: any) => {
	const descr = formatText(data.subtitle)
	const heightTitle = calcBlockHeight(
		data.title,
		usePreloaderFont(data),
		27,
		110,
		Math.min(window.innerWidth - 84, 765)
	)

	return (
		<>
			<TimerWrapp align={data.align}>
				<Timer>
					<PreloaderLine />
				</Timer>
			</TimerWrapp>
			<Lead align={data.align}>
				<div>
					<Header heightTitle={heightTitle}>
						<PreloaderLine />
						<Desc>
							{descr.map((x: { tag: string; text: any }, i: any) =>
								x.tag === 'ulArr' ? (
									<UlWrapp>
										{x.text.map((z: any) => (
											<PreloadUl {...data} {...z} />
										))}
									</UlWrapp>
								) : (
									<AnotherTag>
										<PreloadSubTitle {...data} {...x} key={i} />
									</AnotherTag>
								)
							)}
						</Desc>
					</Header>
					<Form>
						<PreloaderLine />
						<PreloaderLine />
						<PreloaderLine />
					</Form>
					<ButtonBlock>
						<PreloaderLine />
						<Info align={data.align}>
							<PreloaderLine />
							<PreloaderLine />
							<PreloaderLine />
						</Info>
					</ButtonBlock>
				</div>
			</Lead>
		</>
	)
}

const PreloadSubTitle = (data: any) => {
	const heightDescription = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth - 84, 765),
		data
	)

	return <PreloaderLine tag={data.tag} height={heightDescription} />
}

const PreloadUl = (data: any) => {
	const heightUl = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth - 84, 765),
		data
	)

	return <PreloaderLine tag={data.tag} height={heightUl} />
}

const Desc = styled.div`
	width: 100%;
	& > div {
		width: 100%;

		&:last-child {
			margin-bottom: 0;
		}
	}
`

const UlWrapp = styled.div`
	display: flex;
	flex-direction: column;
`

const AnotherTag = styled.div`
	margin-bottom: 0;
`

const Timer = styled.div`
	width: 100%;

	& > div {
		height: 69px;
	}
`

const TimerWrapp = styled.div<{ align: string }>`
	width: 100%;
	display: ${p => (p.align === 'center' ? 'none' : 'flex')};
	align-items: center;
	margin-bottom: 18px;
`

const Lead = styled.div<{ align: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	max-width: 530px;
	align-items: center;
	margin-top: ${p => (p.align !== 'center' ? '8px' : '0')};

	& > div {
		height: ${p => (p.align === 'center' ? 'calc(100% - 4px)' : '100%')};
		width: 100%;
		max-width: 530px;
		padding: 24px;
	}
`

const Header = styled.div<{ heightTitle: number }>`
	gap: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;

	& > div {
		&:nth-child(1) {
			height: ${p => `${p.heightTitle}px`};
			width: 100%;
		}
	}
`

const Form = styled.div`
	margin-top: 24px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	& > div {
		&:nth-child(1) {
			width: 100%;
			height: 56px;
		}
		&:nth-child(2) {
			width: 100%;
			height: 56px;
		}
		&:nth-child(3) {
			width: 100%;
			height: 102px;
		}
	}
`

const Info = styled.div<{ align: string }>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 59px;
	& > div {
		height: 10px;

		&:nth-child(2) {
			width: 60%;
		}

		&:nth-child(1) {
			width: 75%;
		}

		&:nth-child(3) {
			width: 75%;
		}
	}
`

const ButtonBlock = styled.div`
	display: flex;
	gap: 15px;
	margin-top: 16px;
	flex-direction: column;
	& > div {
		display: flex;
		width: 100%;

		&:nth-child(1) {
			height: 48px;
		}

		&:first-child {
			width: 100%;
		}
	}
`
